<template>
  <div class="wrapper">
    <Nav />
    <Slideshow />
    <CustomerCentric />
    <div class="parallax" id="break-1" />
    <GetToKnowUs />
    <div class="parallax" id="break-2" />
    <Difference />
    <Services />
    <div class="parallax" id="break-3" />
    <Switching />
    <SwitchingContact />
    <div class="parallax" id="break-4" />
    <OwnerPortal />
    <Media />
    <div class="parallax" id="break-6" />
    <Testimonials />
    <StrategySession />
    <div class="parallax" id="break-7" />
    <Blog />
    <Contact />
    <footer class="text-white">
      <div class="container py-3">&copy; {{ date }} Bricks & Mortar <a style="color:white !important; margin-left: 30px;" href="/privacy-policy/">Privacy Policy</a></div>
    </footer>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import CustomerCentric from "@/components/CustomerCentric";
import Slideshow from "@/components/Slideshow";
import GetToKnowUs from "@/components/GetToKnowUs";
import Services from "@/components/Services";
import Difference from "@/components/Difference";
import Switching from "@/components/Switching";
import SwitchingContact from "@/components/SwitchingContact";
import OwnerPortal from "@/components/OwnerPortal";
import Media from "@/components/Media";
import Testimonials from "@/components/Testimonials";
import Blog from "@/components/Blog";
import Contact from "@/components/Contact";
import StrategySession from "@/components/StrategySession";

export default {
  name: "Website",
  components: {
    Nav,
    CustomerCentric,
    Slideshow,
    GetToKnowUs,
    Difference,
    Services,
    Switching,
    SwitchingContact,
    OwnerPortal,
    Media,
    Testimonials,
    Blog,
    Contact,
    StrategySession
  },
  data() {
    return {
      date: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss">
$white: #fff;
$black: #000;
$btn-font-weight: 500;
$enable-shadows: true;
$border-radius: 5px;
$font-family-base: "Montserrat", sans-serif;
$enable-responsive-font-sizes: true;
$navbar-dark-color: $white;
$navbar-dark-hover-color: $white;
$navbar-light-color: $black;
$navbar-light-hover-color: $black;
$navbar-light-active-color: $black;
$theme-colors: (
  "secondary": #2c3346,
  "primary": #231f20
);
$container-max-widths: (
  sm: 540px,
  md: 720px,
  lg: 960px,
  xl: 1500px
);

$screen-lg-min: 1200px;
$screen-md-min: 992px;
$screen-sm-min: 768px;


@import "~bootstrap/scss/bootstrap";
body * {
  transition: 0.5s ease all;
}
.container {
  padding-left: 25px;
  padding-right: 25px;
}
body {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body,
.wrapper {
  height: 100%;
}
.text-serif {
  font-family: "Roboto Slab", serif;
}
.display-1,
.display-2,
.display-3,
.display-4 {
  font-family: "Scope One", serif;
}
.bg-transparent-gradient {
  background: rgba(0, 0, 0, 0.2);
  background: -moz-linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  background: -webkit-linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
}
.bg-transparent-gradient-inverse {
  background: rgba(0, 0, 0, 0.2);
  background: -moz-linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  background: -webkit-linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
}
.parallax {
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 600px;
}
video {
  border-radius: 10px;
}
#break-1 {
  background-image: url("./assets/break-1.jpg");
}
#break-2 {
  background-image: url("./assets/break-2.jpg");
}
#break-3 {
  background-image: url("./assets/break-3.jpg");
}
#break-4 {
  background-image: url("./assets/break-4.jpg");
}
#break-6 {
  background-image: url("./assets/break-6.jpg");
}
#break-7 {
  background-image: url("./assets/break-7.jpg");
}
.animate-on {
  opacity: 1;
}
.animate-off {
  opacity: 0;
}
@media (max-width: 992px) {
  .parallax {
    background-size: auto 100%;
    background-repeat: repeat;
    background-position: center;
    background-attachment: scroll;
  }
  #break-7 {
    background-position-x: 30%;
  }
  #strategy-session {
    background-position-x: 60%;
  }
}
/* iPad Pro */
@media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px)
  and (-webkit-min-device-pixel-ratio: 1.5) {

    .parallax {
        background-attachment: scroll;
    }

}
@media (max-width: 576px) {
  #strategy-session {
    background-position-x: 30%;
  }
}
footer.text-white {
  background: #222;
  font-size: 0.8rem;
  
  .container {
    max-width: 1200px;
  }
}

.btn {
    border-radius: 0;
    padding: 10px 25px;
}

.carousel-indicators {
    li {
        width: 50px;
        height: 2px;
        margin-right: 8px;
        margin-left: 8px;
    }
}
</style>
